//
// Splash page
//
import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import PropTypes from 'prop-types';

class SplashPage extends React.Component {
  constructor(props) {
    super(props);
    this.clickHandlerEn = this.clickHandlerEn.bind(this);
    this.clickHandlerEsp = this.clickHandlerEsp.bind(this);
  }

  clickHandlerEn() {
    this.props.chooseLanguage('en');
  }

  clickHandlerEsp() {
    this.props.chooseLanguage('es');
  }

  render() {
    return (
      <div className="splash-title">
        <Row>
          <Col>
            <h1>Ultimate<br />Dinosaurs</h1>
          </Col>
        </Row>
        <Row>
          <Col>
            <p>Audio Guide | Guia de Audio</p>
          </Col>
        </Row>
        <Row>
          <Col className="splash-en-button" sm={12} md={12} lg={{ size: 2, offset: 4 }}>
            <Button
              className="en"
              onClick={this.clickHandlerEn}
            >English
            </Button><br />
          </Col>
          <Col className="splash-en-button" sm={12} md={12} lg={{ size: 2 }}>
            <Button
              className="es"
              onClick={this.clickHandlerEsp}
            >Español
            </Button>
          </Col>
        </Row>
        <Row>
          <Col className="text-center">
            <img
              alt="An artists rendering of a Gigantosaurus lunges forward on one of its two legs, bearing its large jaws. Its skin is striped and multicolored ranging from auburn to dark green."
              className="img-fluid"
              src="https://storage.googleapis.com/ultimatedinos/giganotosaurus.png"
            />
          </Col>
        </Row>
      </div>
    );
  }
}

SplashPage.propTypes = {
  chooseLanguage: PropTypes.func.isRequired,
};

export default SplashPage;



// WEBPACK FOOTER //
// ./src/SplashPage.js